<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'},
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
    />

    <!-- 점검구분 -->
    <div>
      <div>
        <h5><i class="dot"></i>점검구분</h5>
      </div>
      <div class="mt-4 col-span-12 flex items-center">
        <div v-for="check in checklists" class="flex col-span-2 items-center mr-2" style="align-self: flex-start; word-break: keep-all">
          <PrintCheckbox v-if="isPrint || board.readonly" :label="check.label" :value="!!check.value" color />
          <label v-else class="flex">
            <vs-checkbox v-model="form.selectChecklist" :vs-value="check.value" :readonly="board.readonly" />
            {{ check.label }}
          </label>
        </div>

      </div>
    </div>

    <!-- 점검표 -->
    <table-inspect
      v-for="check in checklists"
      v-if="form.selectChecklist.indexOf(check.value) >= 0"
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="check.label"
      :list="form.checkData[check.value]"
      :is-note="true"
      table-header-title="점검항목"
      table-header-yes="적정"
      table-header-no="미흡"
      table-header-na="해당없음"
      @update-list-check="(indexRows, text) => { updateListCheck(check.value, indexRows, text) }"
    />

    <!-- 확인자 -->
    <div class="mt-4">
      <div>
        <h5><i class="dot"></i> 확인자</h5>
      </div>

      <div class="writeGridContainer mt-4">
        <div>
          <div>담당</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div>
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly"  v-model="form.sign1.sign" class="w-full flex-1 p-1"/>
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>팀장</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div>
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly"  v-model="form.sign2.sign" class="w-full flex-1 p-1"/>
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>과장</div>
          <ml-input v-if="!isPrint" v-model="form.sign3.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign3.name }}</span>
        </div>
        <div>
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly"  v-model="form.sign3.sign" class="w-full flex-1 p-1"/>
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign3.sign" :src="form.sign3.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>
    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"/>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from "@/components/TableInspect";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import outdoor from "./outdoor";
import indoor from "./indoor";
import coldPrevention from "./coldPrevention";
import moment from "moment";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  components: {
    PrintCheckbox,
    PhotoUploadGridModule,
    SignField,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    'form.selectChecklist' () {
      if (this.form.selectChecklist.indexOf("indoor") > -1) {
        this.$nextTick(() => {

          // 관리온도 범위를 정하여 일정수준 이내로 유지하고 있는지 - 첫번째 항목 : 휴게실
          const indoor_ck_3_01 = document.querySelector('#indoor_ck_3_01');
          if (indoor_ck_3_01) {
            indoor_ck_3_01.checked = this.form.checkData['indoor'][2].indoor_ck_3_01;
            indoor_ck_3_01.removeEventListener('change', this.onChangeCk3_01)
            indoor_ck_3_01.addEventListener('change', this.onChangeCk3_01);
          }

          // 관리온도 범위를 정하여 일정수준 이내로 유지하고 있는지 - 첫번째 항목 : 근무장소
          const indoor_ck_3_02 = document.querySelector('#indoor_ck_3_02');
          if (indoor_ck_3_02) {
            indoor_ck_3_02.checked = this.form.checkData['indoor'][2].indoor_ck_3_02;
            indoor_ck_3_02.removeEventListener('change', this.onChangeCk3_02)
            indoor_ck_3_02.addEventListener('change', this.onChangeCk3_02);
          }

          // 관리온도 범위를 정하여 일정수준 이내로 유지하고 있는지 - 두번째 항목 : 휴게실
          const indoor_ck_4_01 = document.querySelector('#indoor_ck_4_01');
          if (indoor_ck_4_01) {
            indoor_ck_4_01.checked = this.form.checkData['indoor'][3].indoor_ck_4_01;
            indoor_ck_4_01.removeEventListener('change', this.onChangeCk4_01)
            indoor_ck_4_01.addEventListener('change', this.onChangeCk4_01);
          }

          // 관리온도 범위를 정하여 일정수준 이내로 유지하고 있는지 - 두번째 항목 : 근무장소
          const indoor_ck_4_02 = document.querySelector('#indoor_ck_4_02');
          if (indoor_ck_4_02) {
            indoor_ck_4_02.checked = this.form.checkData['indoor'][3].indoor_ck_4_02;
            indoor_ck_4_02.removeEventListener('change', this.onChangeCk4_02)
            indoor_ck_4_02.addEventListener('change', this.onChangeCk4_02);
          }

        });
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      checklists: [
        {label: "온열질환 예방 안전보건점검표 (실외)", value: 'outdoor'},
        {label: "온열질환 예방 안전보건점검표 (실내)", value: 'indoor'},
        {label: "한랭질환 예방 안전보건점검표", value: 'coldPrevention'}
      ],
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],

        selectChecklist: [],
        checkData: {
          outdoor: outdoor,
          indoor: indoor,
          coldPrevention: coldPrevention,
        },

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
      },
    };
  },
  computed: {
    isPostId() {
      return !!this.$route.params.postId;
    },
    postList() {
      return this.$store.state.approval.list.map((item) => this.getContent(item));
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    onChangeCk3_01(data) {
      this.form.checkData['indoor'][2].indoor_ck_3_01 = data.target.checked;
    },
    onChangeCk3_02(data) {
      this.form.checkData['indoor'][2].indoor_ck_3_02 = data.target.checked;
    },
    onChangeCk4_01(data) {
      this.form.checkData['indoor'][3].indoor_ck_4_01 = data.target.checked;
    },
    onChangeCk4_02(data) {
      this.form.checkData['indoor'][3].indoor_ck_4_02 = data.target.checked;
    },
    updateListCheck (type, indexRows, text) {
      this.form.checkData[type][indexRows].is_checked = text
    }
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

input[type="number"] {
  height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.7rem !important;
  transition: all 0.3s ease;

  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}
</style>
